// Agri Turnkey Solutions — the brand where the product leaves a colour to the site. Loaded with the
// frontend config seam (so on every screen, from the first one), it only sets CSS the product
// leaves open:
// - a line-items DOCUMENT (the delivery note on an Installation & Logistics) wears the ATS teal
//   and gold instead of the product's default red;
// - the catalogue picker of a line (its suggestions are position:fixed) shows under the box being
//   typed in: the work item panel is a CSS container (container-type: inline-size), which makes it
//   the box fixed elements are placed in — in a pop-up, or on a screen taller than the window, the
//   suggestions landed out of sight. While a picker is open the panel is not a container; its
//   container queries are for a panel 700px wide or less, so a computer screen does not change.
const CSS = `
.li-paper { --li-accent: #314e52; }
.li-paper .li-paper-label { color: #8a7020; }
[data-theme="dark"] .li-paper { --li-accent: #9fc6ca; }
[data-theme="dark"] .li-paper .li-paper-label { color: #d9bd62; }
@media (min-width: 760px) { .issue-screen-panel:has(.li-menu) { container-type: normal; } }
`;
if (typeof document !== 'undefined' && !document.getElementById('ats-brand-css')) {
  const el = document.createElement('style');
  el.id = 'ats-brand-css';
  el.textContent = CSS;
  document.head.appendChild(el);
}
